import React from 'react';
import projImg3 from "../../assets/img/n3.png";
import projHellnerG_volatility from "../../assets/img/projHellnerG_volatility.png";
import ShowMoreText from "react-show-more-text";
import { Card } from 'react-bootstrap';

const Gabor_Hellner_hybrid_volatility = () => {
    // Your component logic here

    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Tournament Design</h2></Card.Title> */}

        <Card.Img variant="top" src={projHellnerG_volatility} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg3} />{" "}
            <p className="text7">Gábor Hellner</p>
            <br />
            <p className="text8">
              Blockchain Expert, CEO
              <br />
              CryptoSoft
            </p>
          </Card.Text>
          <ShowMoreText lines={2}>
            <div>
                Cryptocurrency markets are characterized by extreme price movements, high volatility, and regime
                shifts. Classical financial models (GARCH, Heston, Lévy) describe volatility clustering and stochastic
                dynamics well, but they tend to underestimate “fat-tailed” distributions and extreme events. (In
                reality, the distribution of financial returns is not normal: extreme events occur more frequently,
                which is referred to as a “fat tail.”) Modern ML/AI models (LSTM, Transformer) are able to recognize
                nonlinear patterns, while Generative AI (GAN, Diffusion, TimeGAN) can generate realistic scenarios.
                Combining these approaches makes it possible to develop a more realistic and robust forecasting
                system.
                <br />
                This topic represents a particularly exciting research direction, as the integration of Generative AI 
                with the Heston model can enable the construction of a hybrid predictive–simulation framework:

                <ol>
                    <li>
                        The Heston model provides a structured mathematical framework that ensures prices and
                        volatility evolve stochastically but in a “rational” manner (e.g., positive volatility, mean-
                        reversion).
                    </li>
                    <li>
                        Generative AI (GAN, VAE, Diffusion) can generate realistic and complex patterns from data
                        (e.g., bubbles, crashes, and fat-tail events typical in cryptocurrency markets).
                    </li>
                    <li>
                        During integration, price paths simulated from the Heston model are fine-tuned by
                        Generative AI, producing scenarios that are much closer to real crypto-market dynamics.
                    </li>
                </ol>
                
                The essence of such a hybrid analytical system is to combine the structural knowledge of classical
                models (GARCH, Heston, Lévy) with the pattern-recognition power of ML/AI and the scenario-
                generation capabilities of generative models. The system calibrates classical volatility models on
                cryptocurrency data, uses their parameters as inputs to ML/AI models, and extends the simulated
                price paths with Generative AI models (with particular attention to extreme movements), thereby
                producing probabilistic forecasts for future prices.
                The expected outcome of the project is a prototype hybrid forecasting system that provides more
                realistic distributions than classical models and explicitly accounts for the extreme movements
                characteristic of cryptocurrencies.
                <br />
                Such a forecasting system has numerous potential applications, including portfolio risk management
                (Value-at-Risk, Expected Shortfall), derivatives pricing (reproducing the volatility smile), and
                stablecoin collateral risk analysis (stress scenarios).

                <br />
                <br />
                Related literature:{" "}
                <br />
                
                <ul>
                    <li>
                        <i>ML és hybrid financial models</i>
                        <ul>
                            <li>
                                Fischer, T., &amp; Krauss, C. (2018). Deep learning with long short-term memory networks for
                                financial market predictions. 
                                <span className="text9">
                                {" "}
                                European Journal of Operational Research.{" "}
                                </span>
                            </li>
                            <li>
                                Zhang, Z., Zohren, S., &amp; Roberts, S. (2020). Deep learning for finance: deep portfolios.
                                <span className="text9">
                                {" "}
                                Applied Stochastic Models in Business and Industry.{" "}
                                </span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <i>Generative AI</i>
                        <ul>
                            <li>
                                Yoon, J., Jarrett, D., &amp; van der Schaar, M. (2019). Time-series generative adversarial
                                networks.
                                <span className="text9"> NeurIPS. </span>,
                            </li>
                            <li>
                                {" "}
                                Ni, J., Yao, H., &amp; Xu, J. (2020). Conditional GAN for time series prediction. 
                                <span className="text9">
                                IEEE Transactions on Neural Networks and Learning Systems.{" "}
                                </span>{" "}
                            </li>
                        </ul>
                    </li>
                    <li>
                        <i>Others</i>
                        <ul>
                            <li>
                                Goodfellow, I., Pouget-Abadie, J., Mirza, M., Xu, B., Warde-Farley, D., Ozair, S., ... &amp; Bengio, Y.
                                (2014). Generative Adversarial Nets.
                                <span className="text9"> NeurIPS. </span>,
                            </li>
                            <li>
                                Ho, J., Jain, A., &amp; Abbeel, P. (2020). Denoising Diffusion Probabilistic Models.
                                <span className="text9"> NeurIPS. </span>,
                            </li>
                            <li>
                                {" "}
                                Wiese, M., Knobloch, R., Korn, R., &amp; Kretschmer, P. (2020). Quant GANs: Deep Generation of
                                Financial Time Series.
                                <span className="text9">
                                Quantitative Finance, 20(9), 1419–1440.{" "}
                                </span>{" "}
                            </li>
                            <li>
                                {" "}
                                Lahmiri, S., &amp; Bekiros, S. (2019). Cryptocurrency forecasting with deep learning chaotic neural
                                networks.
                                <span className="text9">
                                Chaos, Solitons &amp; Fractals, 118, 35–40.{" "}
                                </span>{" "}
                            </li>
                            <li>
                                {" "}
                                Li, T., Shin, D., &amp; Wang, B. (2022). Generative Models for Financial Applications.
                                <span className="text9">
                                Computing Surveys, 55(6), 1–38.{" "}
                                </span>{" "}
                            </li>
                        </ul>
                    </li>
                
                
                </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gabor_Hellner_hybrid_volatility;